import {FormFieldT, FormStepT} from '@/lib/types/form.types';

type SignUpFormDataT = {
  email: string;
  password: string;
  confirmPassword: string;
  terms: boolean;
};

/****************************************************************************
 * Form Fields
 ****************************************************************************/
export const signUpFormFields: FormFieldT<SignUpFormDataT>[] = [
  {
    label: 'Email Address',
    name: 'email',
    type: 'email',
    placeholder: 'Email address',
    options: {
      required: 'Email is required',
      pattern: {
        value: /^\S+@\S+$/i,
        message: 'Invalid email address',
      },
    },
  },
  {
    label: 'Password',
    name: 'password',
    type: 'password',
    placeholder: 'Password',
    options: {
      required: 'Password is required',
      minLength: {
        value: 6,
        message: 'Password must be at least 6 characters',
      },
    },
    watch: {
      enabled: true,
      onChange: ({formContext}) => {
        // When password changes, validate confirmPassword if it has a value
        const confirmPassword = formContext.getValues('confirmPassword');
        if (confirmPassword) {
          formContext.trigger('confirmPassword');
        }
      },
    },
  },
  {
    label: 'Confirm Password',
    name: 'confirmPassword',
    type: 'password',
    placeholder: 'Confirm password',
    options: {
      required: 'Please confirm your password',
      validate: (value, formValues) => {
        if (!value) return true; // Let required handle empty case
        return value === formValues.password || 'Passwords do not match';
      },
    },
  },
  {
    label: 'I agree to the Terms & Conditions and Privacy Policy',
    name: 'terms',
    type: 'checkbox',
    size: 'lg',
    options: {
      required: 'You must agree to our terms and conditions and privacy policy',
    },
  },
];

export type SignUpFieldNamesT = (typeof signUpFormFields)[number]['name'];

/****************************************************************************
 * Form Steps
 ****************************************************************************/
export const signUpFormSteps: FormStepT<SignUpFieldNamesT> = [
  {
    step: 0,
    label: 'Sign Up',
    fields: ['email', 'password', 'confirmPassword', 'terms'],
  },
];
